import { createFileRoute } from '@tanstack/react-router'
import PurchaseRequestScreen from './-components/screen'
import { pharmacyClient } from '@/connect'
import { Loading } from '@/layouts/loading'
import { z } from 'zod'

const PurchaseReturnParams = z.object({
  page: z.number().default(1),
  pageSize: z.number().default(10),
  supplierId: z.string().default('all')
})

export const Route = createFileRoute('/(pharma)/_layout/reports/purchase-returns-list/')({
  component: PurchaseRequestScreen,
  validateSearch: PurchaseReturnParams
})